import { motion } from 'framer-motion'
import useReducedMotion from '../../hooks/useReducedMotion'

/**
 * Gorizontal arabesque chiziq — section divider sifatida.
 * Scroll'ga kirgach path-length 0→1 chizadi (720ms cinematic).
 */
export default function ArabesqueBorder({ className = '', color = 'currentColor' }) {
  const reduced = useReducedMotion()

  return (
    <svg
      className={`w-full h-[40px] text-white/40 ${className}`}
      viewBox="0 0 1200 60"
      preserveAspectRatio="none"
      fill="none"
      stroke={color}
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <motion.line
        x1="0" y1="30" x2="1200" y2="30"
        initial={reduced ? false : { pathLength: 0, opacity: 0 }}
        whileInView={{ pathLength: 1, opacity: 1 }}
        viewport={{ once: true, margin: '-50px' }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      />
      {Array.from({ length: 10 }).map((_, i) => {
        const x = 40 + i * 120
        return (
          <motion.path
            key={i}
            d={`M${x} 30 Q${x + 20} 10 ${x + 40} 30 Q${x + 60} 50 ${x + 80} 30`}
            initial={reduced ? false : { pathLength: 0, opacity: 0 }}
            whileInView={{ pathLength: 1, opacity: 1 }}
            viewport={{ once: true, margin: '-50px' }}
            transition={{ duration: 1, delay: 0.2 + i * 0.04, ease: [0.22, 1, 0.36, 1] }}
          />
        )
      })}
      {Array.from({ length: 10 }).map((_, i) => (
        <motion.circle
          key={`c${i}`}
          cx={100 + i * 120}
          cy={30}
          r={3}
          fill="currentColor"
          stroke="none"
          initial={reduced ? false : { scale: 0, opacity: 0 }}
          whileInView={{ scale: 1, opacity: 1 }}
          viewport={{ once: true, margin: '-50px' }}
          transition={{ duration: 0.4, delay: 0.6 + i * 0.04, ease: [0.22, 1, 0.36, 1] }}
        />
      ))}
    </svg>
  )
}
